export default "__VITE_ASSET__DOOqmCrE__"